module.exports = __webpack_public_path__ + "img/98coupon.1a6114f9.png";